import { useRegisterToken } from '@/contexts/register-token';
import { ROUTES } from '@/routes';
import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useSearchParams } from 'react-router-dom';

// 임시!
const ShopbyRegisterStartPage = () => {
  const [searchParams] = useSearchParams();
  const { setShopbyToken } = useRegisterToken();
  const navigate = useNavigate();

  useEffect(() => {
    const code = searchParams.get('code') || '';
    setShopbyToken(code);
    navigate(ROUTES.signin);
  }, []);

  return <></>;
};

export default ShopbyRegisterStartPage;
